

import React, { useState, useEffect, useRef } from "react";
import "./style/infomap.css";
import { assets } from "../../../assets/assets";
import { getStatistics } from '../../../api/main_Map/statistics'; 
import ar from "../../../lang/ar";
import en from "../../../lang/en";
function InfoMap({ isInfoOpen, onToggleInfo, lang }) {
    const translations = lang === "ar" ? ar : en;

  const collapseRef = useRef(null);
  const [height, setHeight] = useState(0);
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isInfoOpen && collapseRef.current) {
      setHeight(collapseRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isInfoOpen]);

  // جلب الإحصائيات عند تحميل الكومبوننت
  useEffect(() => {
    const fetchStatistics = async () => {
      setLoading(true);
      try {
        const data = await getStatistics();
        if (data.success) {
          setStatistics(data.data); // هنا بسخن البيانات من "data"
        }
      } catch (error) {
        console.error('Failed to fetch statistics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, []);

  // إنشاء عناصر العرض بناءً على البيانات من API
  const infoItems = statistics
    ? [
        { label: translations.totalLandArea, value: `${statistics.total_land_area} m²` },
        { label: translations.totalResidence, value: statistics.total_residence },
        { label: translations.landscape, value: `${statistics.landscape} m²` },
        { label: translations.totalResiUnits, value: statistics.total_resi_units },
        { label: translations.projectBUA, value: `${statistics.project_bua} m²` },
      ]
    : []; 

  return (
    <div className={`info-container`} dir={lang === "ar" ? "rtl" : "ltr"}>
        <button
          className="btn icon-container"
          type="button"
          onClick={onToggleInfo}
          aria-expanded={isInfoOpen}
        >
           <img src={assets.info} alt="Info Icon" />
        </button>

        <div
          ref={collapseRef}
          className={`info-collapse ${isInfoOpen ? "open" : ""}`}
          style={{
            height: `${height}px`,
            overflow: "hidden",
            transition: "height 0.5s ease-in-out",
          }}
        >
          <div className="info-map-content-">
            {loading ? (
              <p>Loading statistics...</p>
            ) : statistics ? (
              infoItems.map((item, index) => (
                <div className="info-map-content-items-" key={index}>
                  <p className="m-0 p-0">{item.label}</p>
                  <p className="m-0 p-0">{item.value}</p>
                </div>
              ))
            ) : (
              <p>No statistics available.</p>
            )}
          </div>
        </div>
    </div>
  );
}

export default InfoMap;













// import React, { useState, useEffect, useRef } from "react";
// import "./style/infomap.css";
// import { assets } from "../../../assets/assets";
// import { getStatistics } from '../../../api/main_Map/statistics'; 
// import ar from "../../../lang/ar";
// import en from "../../../lang/en";

// function InfoMap({ isInfoOpen, onToggleInfo, lang, projectSlug }) {
//   const translations = lang === "ar" ? ar : en;
//   const collapseRef = useRef(null);
//   const [height, setHeight] = useState(0);
//   const [statistics, setStatistics] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // ✅ التعديل الأول: حساب الطول عند فتح المنيو "أو" عند وصول البيانات
//   useEffect(() => {
//     if (isInfoOpen && collapseRef.current) {
//       setHeight(collapseRef.current.scrollHeight);
//     } else {
//       setHeight(0);
//     }
//   }, [isInfoOpen, statistics]); // ضفنا statistics هنا عشان يحس لما البيانات توصل

// useEffect(() => {
//     const fetchStatistics = async () => {
//       // لو الـ slug لسه مجاش من الـ Router، متبعتش request غلط
//       if (!projectSlug || projectSlug === "_" || projectSlug === "undefined") {
//         console.warn("⚠️ Waiting for a valid projectSlug...");
//         return;
//       }

//       console.log("🚀 Fetching stats for:", projectSlug); // عشان تشوفي في الـ console الـ slug صح ولا لأ
//       setLoading(true);
//       try {
//         const data = await getStatistics(projectSlug);
//         if (data && data.success) {
//           setStatistics(data.data);
//           console.log("✅ Stats received:", data.data);
//         } else {
//           setStatistics(null);
//         }
//       } catch (error) {
//         console.error('❌ Failed to fetch statistics:', error);
//         setStatistics(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStatistics();
//   }, [projectSlug]);
//   const infoItems = statistics
//     ? [
//         { label: translations.totalLandArea, value: `${statistics.total_land_area} m²` },
//         { label: translations.totalResidence, value: statistics.total_residence },
//         { label: translations.landscape, value: `${statistics.landscape} m²` },
//         { label: translations.totalResiUnits, value: statistics.total_resi_units },
//         { label: translations.projectBUA, value: `${statistics.project_bua} m²` },
//       ]
//     : []; 

//   return (
//     <div className={`info-container`} dir={lang === "ar" ? "rtl" : "ltr"}>
//         <button
//           className="btn icon-container"
//           type="button"
//           onClick={onToggleInfo}
//           aria-expanded={isInfoOpen}
//         >
//            <img src={assets.info} alt="Info Icon" />
//         </button>

//         <div
//           ref={collapseRef}
//           className={`info-collapse ${isInfoOpen ? "open" : ""}`}
//           style={{
//             height: `${height}px`,
//             overflow: "hidden",
//             transition: "height 0.5s ease-in-out",
//           }}
//         >
//           <div className="info-map-content-">
//             {loading ? (
//               <p className="p-2 text-center" style={{fontSize: '12px'}}>Loading...</p>
//             ) : statistics ? (
//               infoItems.map((item, index) => (
//                 <div className="info-map-content-items-" key={index}>
//                   <p className="m-0 p-0">{item.label}</p>
//                   <p className="m-0 p-0">{item.value}</p>
//                 </div>
//               ))
//             ) : (
//               <p className="p-2 text-center" style={{fontSize: '12px'}}>No statistics available.</p>
//             )}
//           </div>
//         </div>
//     </div>
//   );
// }

// export default InfoMap;